import { ViolationStatusesEnum } from 'APIPackage/KnmModule/enums/ViolationStatusesEnum';

export const mapViolationStatusToLabel: Record<ViolationStatusesEnum, string> = {
  [ViolationStatusesEnum.CANCELED]: 'Отменено',
  [ViolationStatusesEnum.APPEALED]: 'Успешно обжаловано',
  [ViolationStatusesEnum.FIXED]: 'Устранено',
  [ViolationStatusesEnum.NOT_FIXED]: 'Не устранено',
  [ViolationStatusesEnum.UNFIXABLE]: 'Не подлежит устранению',
  [ViolationStatusesEnum.APPROVING]: 'Ожидает подтверждения',
  [ViolationStatusesEnum.SUSPENDED_BY_AGREEMENT]: 'Приостановлено по соглашению',
};
